export const getUrl = (title) =>
  title
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[á]/g, 'a')
    .replace(/[é]/g, 'e')
    .replace(/[í]/g, 'i')
    .replace(/[óöő]/g, 'o')
    .replace(/[úüű]/g, 'u');
